import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageMarbella = props => {
  return <CityLandingPage cityKey="Marbella" cityConfig={cityContent.marbella} {...props} />;
};

export default LandingPageMarbella;
